<template>
  <div>
    <h2 class="bb-page-title">
      {{ isFounder ? 'Companies' : 'Company'}}
    </h2>
    <div class="bb-companies-container">
      <transition name="fade" appear>
        <loader-fly v-if="loaderRun"/>
      </transition>
      <div
        v-for="(item,index) in list"
        :key="item.id"
        :class="{'bb-companies-item_hide':item.hide}">
        <div class="bb-company bb-companies-item" v-click-outside="hide">
          <div class="bb-company-menu-container">
            <i class="icon-menu bb-company-menu-container__toolbar" @click.stop="toolbarOpen(index)"/>
            <transition name="bounce">
              <div class="bb-company-menu-container__options"
                   v-if="toolbarActive === index"
                   v-click-outside="hide"
              >
                <img
                  src="@/assets/images/icon-pencil.png"
                  @click.stop="editCompanyForm(item)"
                />
                <img
                  v-if="isFounder"
                  src="@/assets/images/icon-delete.png"
                  @click.stop="deleteConfirmOpen(index)"
                />
              </div>
            </transition>
          </div>
          <div class="bb-company-logo">
            <img class="bb-company-logo__img" :src="item.image ? item.image.path : logoCompany"/>
          </div>
          <div class="bb-company__name" v-if="editCompanyIndex!==index">{{ item.name }}</div>
          <transition name="fade">
            <div class="bb-company-delete"
                 v-if="(deleteConfirm || deleteConfirm === 0) && toolbarActive===index"
                 @click.stop
            >
              <span class="bb-company-delete__text">Are you sure?</span>
              <div class="bb-company-delete__btn-wrapper">
                <button class="bb-company-delete__btn" type="submit" @click="openDelete(index)">Yes
                </button>
                <button class="bb-company-delete__btn" type="submit" @click="deleteConfirm = false">No</button>
              </div>
            </div>
          </transition>
        </div>
        <DoubleDelete v-if="openDoubleDelete === index"
                      :id="item.id"
                      :title="item.name"
                      @close="hide"
                      @delete="deleteCompany"
        />
      </div>
      <transition name="slide-fade">
        <div class="bb-companies-add-form bb-companies-item"
             :class="{'bb-companies-add-form__row_img': imgSrc}"
             v-click-outside="hideNewCompany"
             @click.stop
             v-if="addCompanyFormOpen">
          <template v-if="!imgSrc">
            <div class="bb-companies-upload-form">
              <div class="bb-companies-upload-form__continer-file-input">
                <input class="bb-companies-upload-form__file-input"
                       name="upload-logo"
                       type="file"
                       accept="image/*"
                       id="upload-logo"
                       @change="processFile($event)">
                <img class="bb-companies-upload-form__icon-file-input" src="@/assets/images/icon-add-image.png"/>
              </div>
              <label class="bb-companies-upload-form__label" for="upload-logo">Upload logo</label>
            </div>
          </template>
          <template v-else>
            <div class="bb-company-logo">
              <img class="bb-company-logo__img" :src="imgSrc || logoCompany"/>
              <input class="bb-company-logo__file-input"
                     name="upload-logo"
                     type="file"
                     accept="image/*"
                     @click.stop
                     @change="processFile($event)">
              <img class="bb-company-logo__icon-edit" src="@/assets/images/edit.png"/>
            </div>
          </template>
          <div class="bb-company-edit">
            <div class="bb-companies-add-form__row">
              <input
                class="bb-companies-add-form__text-input bb-input bb-input_border"
                :class="{'bb-companies-add-form__text-input_error': invalidName}"
                v-autofocus
                @keyup.esc="hideNewCompany()"
                @keyup.enter="addCompany()"
                type="text"
                v-model="company.name"/>
              <button class="bb-companies-add-form__btn bb-button" type="submit" @click="addCompany()">OK
              </button>
            </div>
          </div>
        </div>
      </transition>
      <transition name="fade-el">
        <div
          v-if="isFounder"
          class="bb-companies-btn-add bb-companies-item"
          @click.stop="addCompanyForm()"
        >
          <img class='bb-companies-btn-add__image-add-company' src="@/assets/images/icon-add-company.png"/>
        </div>
      </transition>
    </div>
    <ModalWindow
      v-if="showEditCompany"
      @close="onOpenModal"
      :scrollToError="!!errorField"
      customWrapperClass="bb-modal-wrapper_padding"
    >
      <CompanyForm
        :company="editedCompany"
        :errorField="errorField"
      />
      <template v-slot:buttons>
        <button
          class="bb-button company-form-btn"
          @click="saveCompany"
        >
          {{ editedCompany.id ? 'Save' : 'Add company'}}
        </button>
      </template>
    </ModalWindow>
    <ModalWindow v-if="file" @close="file = false" @click.stop>
      <UploadImage :file="file" @uploadFile="setFileData" @click.stop/>
    </ModalWindow>
  </div>
</template>

<script>
import CompaniesApi from '@/api/Companies/api'
import logoCompanyDefault from '@/assets/images/avatar-company-default-big.png'
import LoaderFly from '@/components/Main/Loaders/LoaderFly'
import {FOUNDER} from '@/constants/roles'
import ClickOutside from 'vue-click-outside'
import DoubleDelete from '@/components/Main/DoubleDelete/DoubleDelete'
import {uniqueId, get, set, findIndex, merge, cloneDeep} from 'lodash'
import UploadImage from '@/components/Main/UploadImage/UploadImage'
import ModalWindow from '@/components/Main/ModalWindow/ModalWindow'
import UploadFileApi from '@/api/UploadFile/api'
import CompanyForm from './CompanyForm/CompanyForm'

export default {
  name: 'SettingsCompanies',
  components: {
    LoaderFly,
    DoubleDelete,
    UploadImage,
    ModalWindow,
    CompanyForm
  },
  directives: {ClickOutside},
  data: function () {
    return {
      company: {},
      imgSrc: false,
      newCompanyFile: false,
      file: false,
      invalidName: false,
      openDoubleDelete: false,
      hiddenForm: false,
      loaderRun: false,
      deleteConfirm: false,
      editCompanyIndex: false,
      toolbarStatus: false,
      toolbarActive: '',
      logoCompany: logoCompanyDefault,
      addCompanyFormOpen: false,
      getCompanies: true,
      showEditCompany: false,
      defaultCompany: {
        name: '',
        website: '',
        emailDomain: '',
        clientId: '',
        clientSecret: '',
        phone: '',
        skype: '',
        whatsapp: '',
        address: '',
        socialMedia: [],
        commercialOfferType: 1,
        url: '',
        commercialOfferCompanyNameRU: '',
        commercialOfferCompanyNameEN: '',
        signatureType: 1,
        details: [
          {
            _id: uniqueId(),
            text: '',
            link: ''
          }
        ],
        invoiceType: 1,
        invoiceDetails: [
          {
            _id: uniqueId(),
            text: ''
          }
        ],
        isTaxInvoice: true,
        invoicePrefix: '',
        invoiceTerms: '',
        serviceName: '',
        clientResponsible: null,
        clientNotification: ''
      },
      errorField: '',
      editedCompany: {},
      indexCompaniesList: 0
    }
  },
  computed: {
    userInfo: function () {
      return this.$store.getters.userInfo
    },
    isFounder () {
      return (this.userInfo.role === FOUNDER.id)
    },
    companiesList: {
      get: function () {
        return this.$store.getters.companiesList
      },
      set: function (data) {
        this.$store.dispatch('setCompaniesList', data)
      }
    },
    currentCompany: {
      get () {
        return this.$store.getters.currentCompany
      },
      set (data) {
        this.$store.dispatch('setCurrentCompany', data)
      }
    },
    list () {
      return this.isFounder ? this.companiesList : [this.currentCompany]
    },
    activeCompany: {
      get: function () {
        return this.$store.getters.activeCompany
      },
      set: function (data) {
        this.$store.dispatch('setActiveCompany', data)
      }
    }
  },
  methods: {
    onOpenModal () {
      this.showEditCompany = false
    },
    openDelete (index) {
      this.openDoubleDelete = index
    },
    hide: function () {
      this.toolbarStatus = false
      this.toolbarActive = false
      this.deleteConfirm = false
      this.editCompanyIndex = false
      this.openDoubleDelete = false
      this.editCompanyOpen = false
      this.imgSrc = false
    },
    hideNewCompany () {
      const lastItem = this.companiesList.length - 1
      this.companiesList.splice(lastItem, 1)
      this.addCompanyFormOpen = false
    },
    validateForm (company) {
      this.invalidName = !company.name
    },
    async addCompany () {
      if (this.newCompanyFile) {
        const data = await this.uploadFile()
        this.company.image = data.id
      }
      this.validateForm(this.company)
      if (this.invalidName) return
      this.hiddenForm = true
      this.loaderRun = true
      CompaniesApi.addCompany({company: this.company})
        .then((resp) => {
          this.loaderRun = false
          this.invalidName = false
          this.addCompanyFormOpen = false
          this.company.name = ''
          const {image, ...newCompany} = this.company
          this.company = newCompany
          if (this.companiesList.length === 1) {
            this.activeCompany = resp.data.id
            this.$cookie.set('company', resp.data.id)
          }
          this.companiesList.splice(this.companiesList.length - 1, 1, resp.data)
          if (this.newCompanyFile) {
            const index = findIndex(this.companiesList, {id: resp.data.id})
            this.$set(this.companiesList[index], 'image', resp.data.image)
            this.newCompanyFile = false
            this.imgSrc = false
          }
        })
        .catch((err) => {
          this.loaderRun = false
          console.error(err)
        })
    },
    async createCompany (company) {
      this.loaderRun = true
      await CompaniesApi.addCompany({company})
        .then(({data}) => {
          this.loaderRun = false
          this.companiesList.unshift(data)
          this.editedCompany = {}
          this.showEditCompany = false
        })
        .catch((err) => {
          this.loaderRun = false
          console.error(err)
        })
    },
    async editCompany (company, id) {
      this.loaderRun = true
      CompaniesApi.editCompany({company}, id)
        .then(({data}) => {
          const companyList = this.isFounder ? 'companiesList' : 'list'
          const indexEditCompany = this[companyList].findIndex((item) => item.id === id)
          if (indexEditCompany !== -1) {
            this[companyList].splice(indexEditCompany, 1, data)
          }
          if (id === this.currentCompany.id) {
            this.currentCompany = data
          }
          this.loaderRun = false
          this.editedCompany = {}
          this.showEditCompany = false
        })
        .catch((err) => {
          console.error(err)
        })
    },
    deleteCompany (id) {
      const index = findIndex(this.companiesList, {id: id})
      this.loaderRun = true
      this.companiesList.splice(index, 1)
      CompaniesApi.delCompany(id)
        .then((resp) => {
          if (this.companiesList.length === 0) {
            this.activeCompany = ''
            this.$cookie.delete('company')
          }
          this.deleteConfirm = false
          this.openDoubleDelete = false
          this.loaderRun = false
        })
        .catch((err) => {
          this.loaderRun = false
          console.error(err)
        })
      this.toolbarActive = false
    },
    setFileData (fileData, file) {
      const id = get(this.editedCompany, 'id', '')
      const label = fileData.get('file').name
      fileData.set('fieldname', 'uploadFile')
      fileData.set('label', label)
      fileData.set('parentId', id)
      fileData.set('onModel', 'Company')
      this.file = false
      this.imgSrc = file
      set(this.editedCompany, 'image.path', file)
      set(this.companiesList[this.indexCompaniesList], 'image.path', file)
      this.newCompanyFile = fileData
    },
    async uploadFile () {
      this.loaderRun = true
      try {
        const res = await UploadFileApi.createFile(this.newCompanyFile)
        this.loaderRun = false
        return res.data
      } catch (err) {
        console.error(err)
        this.loaderRun = false
      }
    },
    processFile (e, index) {
      this.indexCompaniesList = index
      const files = e.target.files || e.dataTransfer.files
      if (!files.length) return
      this.file = files[0]
    },
    isValidURL (str) {
      const pattern = new RegExp('^(https?:\\/\\/)' + // protocol
        '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
        '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
        '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
        '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
        '(\\#[-a-z\\d_]*)?$', 'i') // fragment locator
      return !!pattern.test(str)
    },
    saveCompany () {
      const {
        name,
        image: imageObj = {},
        id,
        socialMedia: socialMediaList,
        details: detailsList,
        invoiceDetails: invoiceDetailsList,
        url: urlLink,
        serviceName
      } = this.editedCompany
      this.errorField = ''
      const socialMedia = socialMediaList.map((item) => ({...item, _id: undefined}))
      const details = detailsList.map((item) => ({...item, _id: undefined}))
      const invoiceDetails = invoiceDetailsList.map((item) => ({...item, _id: undefined}))
      const { id: image } = imageObj
      const isValidURL = this.isValidURL(urlLink)
      if (!name || !isValidURL || !serviceName) {
        setTimeout(() => {
          if (name && urlLink) {
            this.errorField = 'serviceName'
          } else {
            this.errorField = name ? 'url' : 'companyTitle'
          }
        })
        return
      }
      const url = urlLink[urlLink.length - 1] === '/' ? urlLink.slice(0, -1) : urlLink
      this.errorField = ''
      const company = {
        ...this.editedCompany,
        image,
        socialMedia,
        details,
        invoiceDetails,
        url,
        id: undefined
      }
      if (id) {
        this.editCompany(company, id)
      } else {
        this.createCompany(company)
      }
    },
    addCompanyForm () {
      this.showEditCompany = true
      this.editedCompany = cloneDeep(this.defaultCompany)
    },
    toolbarOpen (index) {
      this.editCompanyOpen = false
      this.editCompanyIndex = false
      this.toolbarActive = index
      this.toolbarStatus = true
      this.deleteConfirm = false
    },
    editCompanyForm (company) {
      this.toolbarActive = false
      this.showEditCompany = true
      const editedCompany = cloneDeep(company)
      const defaultCompany = cloneDeep(this.defaultCompany)
      this.editedCompany = merge(defaultCompany, editedCompany)
    },
    deleteConfirmOpen (index) {
      this.deleteConfirm = index
      this.editCompanyOpen = false
      this.editCompanyIndex = false
    }
  },
  beforeMount: function () {
    if (this.companiesList.length === 0 && this.isFounder) {
      this.loaderRun = true
      CompaniesApi.getCompanies()
        .then((resp) => {
          this.companiesList = resp.data.companies
          this.loaderRun = false
        })
        .catch((err) => {
          this.loaderRun = false
          console.error(err)
        })
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../sass/variables";
  @import "../../../sass/transition";
  @import "../../../sass/mixins";

  .bb-companies {

    &-container {
      @include global-font;
      display: flex;
      flex-wrap: wrap;
      margin: 23px 0 23px -15px;

      .bb-company {
        position: relative;
        justify-content: space-between;
        padding: 0 0 23px;
        box-shadow: 0 0 20px rgba($color-black, 0.1);

        &-logo {
          position: relative;
          display: flex;
          justify-content: center;
          margin-top: 31px;

          &__img {
            border-radius: 50%;
            width: 98px;
            height: 98px;
          }

          &__icon-edit {
            border-radius: 50%;
            position: absolute;
            bottom: -10px;
            width: 26px;
            height: 26px;
            pointer-events: none;
            cursor: pointer;
          }

          &__file-input {
            position: absolute;
            bottom: -10px;
            width: 26px;
            height: 26px;
            opacity: 0;
            z-index: 1;
            font-size: 0;
            cursor: pointer;
          }
        }

        &__name {
          text-align: center;
          margin-top: 15px;
          font-size: 14px;
          line-height: 17px;
        }

        &-menu-container {
          position: absolute;
          top: 7px;
          right: 5px;
          user-select: none;

          &__toolbar {
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 10px;
            color: $color-accent;
            cursor: pointer;
            width: 25px;
            height: 30px;
          }

          &__options {
            position: absolute;
            top: 7px;
            right: 5px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            grid-gap: 6px;
            padding: 7px;
            height: 36px;
            background: $color-white;
            box-shadow: 0 0 15px rgba($color-black, 0.1);
            border-radius: 4px;
            cursor: pointer;
            z-index: 1;

            img {
              width: 21px;
              height: 21px;
            }
          }
        }

        &-delete {
          position: absolute;
          top: 0;
          left: 0;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          width: 100%;
          height: 100%;
          background: rgba($color-white, 0.93);
          backdrop-filter: blur(4px);
          border-radius: 15px;

          &__btn-wrapper {
            display: flex;
            justify-content: space-between;
            width: 100%;
            padding: 0 47px;
          }

          &__btn {
            margin-top: 13px;
            padding: 8px 10px;
            color: $color-white;
            background: $color-accent;
            border-radius: 4px;
            cursor: pointer;
          }
        }

        &-edit {
          position: absolute;
          bottom: 0;
          left: 0;
          padding: 12px 12px;
        }

      }
    }

    &-item {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      width: 184px;
      height: 184px;
      border-radius: 15px;
      background: $color-white;
      margin: 15px;

      &_hide {
        opacity: 0;
        position: absolute;
        z-index: -1;
      }
    }

    &-btn-add {
      transition: box-shadow .15s ease-in;

      &:hover {
        box-shadow: 0 0 20px rgba($color-black, 0.1);
        cursor: pointer;
      }

      &__image-add-company {
        width: 66px;
        height: 66px;
      }
    }

    &-add-form {
      position: relative;
      justify-content: space-evenly;
      align-items: stretch;
      padding: 0 12px 19px;

      &__row {
        display: flex;
        justify-content: space-evenly;
        margin-top: 36px;

        &_img {
          justify-content: space-between;
        }
      }

      &__text-input {
        padding: 4px 8px;
        width: 50%;
        flex-grow: 2;

        &_error {
          animation: shake .3s ease-out;
          border-color: $color-red-orange;
        }
      }

      &__btn {
        height: 100%;
        margin-left: 10px;
        padding: 8px 10px;
      }
    }

    &-upload-form {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      cursor: pointer;
      margin: auto 0;

      &__continer-file-input {
        position: relative;
        width: 34px;
        height: 34px;
      }

      &__file-input {
        position: absolute;
        width: 100%;
        height: 100%;
        opacity: 0;
        z-index: 1;
      }

      &__icon-file-input {
        position: absolute;
        width: 100%;
        height: 100%;
      }

      &__label {
        margin-top: 6px;
        color: $color-accent;
        font-size: 11px;
        line-height: 13px;
      }

    }
  }

  .company-form-btn {
    z-index: 0;
    margin-top: 32px;
    text-transform: uppercase;
    padding-left: 35px;
    padding-right: 35px;
    align-self: center;
    min-height: 42px;
    max-height: 42px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Settings/Companies/Companies.vue